module.exports = __webpack_public_path__ + "media/images/locations/liestal-0eb5068b8b92a0a9ddf34d3c3b254f8a.jpg";